// extracted by mini-css-extract-plugin
export default {"root":"BannerOutside-root","left":"BannerOutside-left","right":"BannerOutside-right"};